import { render, staticRenderFns } from "./SlideVerify.vue?vue&type=template&id=5fa312fb&scoped=true&"
import script from "./SlideVerify.vue?vue&type=script&lang=js&"
export * from "./SlideVerify.vue?vue&type=script&lang=js&"
import style0 from "./SlideVerify.vue?vue&type=style&index=0&id=5fa312fb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa312fb",
  null
  
)

export default component.exports